import { useArticles } from "../lib/editApi.js";
import ArticleCard, { CategoryChips } from "../site/ArticleCard.jsx";

export default function EditIndexPage() {
  const { articles, loaded } = useArticles();
  const [lead, ...rest] = articles;

  return (
    <div className="container-page py-16 md:py-20">
      <header className="max-w-2xl">
        <span className="eyebrow">The Hawaiʻi Edit</span>
        <h1 className="section-title mt-3">Guides from people who actually live here.</h1>
        <p className="prose-body mt-4 text-lg">
          When to come, which island suits the trip you have in mind, and where to stay once you have
          picked one. Written to help you book well, not to fill a content calendar.
        </p>
      </header>

      <div className="mt-10"><CategoryChips/></div>

      {!articles.length && loaded && (
        <p className="prose-body mt-16">No guides published yet.</p>
      )}

      {lead && (
        <a href={`/${lead.category}/${lead.slug}/`} className="card group mt-12 grid overflow-hidden md:grid-cols-2">
          <div className="aspect-[16/10] overflow-hidden bg-sand-100 md:aspect-auto md:h-full md:min-h-[320px]">
            {lead.img && <img src={lead.img} alt={lead.title} style={{ objectPosition: lead.imgPosition || "center center" }} className="h-full w-full object-cover transition duration-700 group-hover:scale-105"/>}
          </div>
          <div className="flex flex-col justify-center p-8 md:p-12">
            <span className="eyebrow">Latest</span>
            <h2 className="mt-3 font-display text-2xl leading-tight text-ink group-hover:text-ocean-700 md:text-3xl">{lead.title}</h2>
            {lead.excerpt && <p className="prose-body mt-4">{lead.excerpt}</p>}
            <span className="mt-6 text-sm font-medium text-ocean-700">Read the guide →</span>
          </div>
        </a>
      )}

      {rest.length > 0 && (
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map(a => <ArticleCard key={`${a.category}/${a.slug}`} article={a}/>)}
        </div>
      )}
    </div>
  );
}
